export const SUBSCRIPTIONS = ['trial', 'advanced', 'basic'];
export const PLANS_PERIOD = [1, 3, 6, 12];
export const TRIAL_PLAN = 'trial';

export const LIMIT_OPTIONS = {
  livestock: [250, 500, 750, 1000],
  farms: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
  geofences: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
  sites: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
  rules: [20, 40, 60, 80, 100],
  sms: [25, 50, 75, 100]
};
export const PLANS_STATUS = {
  ACTIVE: 'active',
  PENDING: 'pending',
  INACTIVE: 'inactive'
};

export const PLAN_TYPE = {
  ADVANCED: 'advanced',
  BASIC: 'basic',
  COMPLETED: 'complete',
  TRACKING: 'tracking',
  TRIAL: 'trial'
};

export const ALL_PLANS = Object.values(PLAN_TYPE);

export const STATUS_COLOR = {
  active: 'green',
  pending: 'blue',
  inactive: 'red'
};

export const FEATURE_LIST = {
  ACTIVE_LIVESTOCK_WIDGET: 'ACTIVE_LIVESTOCK_WIDGET',
  ACTIVE_NOTIFICATIONS_WIDGET: 'ACTIVE_NOTIFICATIONS_WIDGET',
  ACTIVE_RULES_WIDGET: 'ACTIVE_RULES_WIDGET',
  BASIC_LIVESTOCK_LIST_TRACKING: 'BASIC_LIVESTOCK_LIST_TRACKING',
  BREEDING_TAB: 'BREEDING_TAB',
  CALENDAR: 'CALENDAR',
  CALENDAR_WIDGET: 'CALENDAR_WIDGET',
  CALVES_PRODUCED_WIDGET: 'CALVES_PRODUCED_WIDGET',
  CALVES_WEANED_WIDGET: 'CALVES_WEANED_WIDGET',
  CONTACT_US: 'CONTACT_US',
  FARMS_LIST: 'FARMS_LIST',
  FARM_DETAILS_FIELDS: 'FARM_DETAILS_FIELDS',
  FARM_FILTER: 'FARM_FILTER',
  GEOFENCES_LIST: 'GEOFENCES_LIST',
  GEOFENCE_DETAILS_FIELDS: 'GEOFENCE_DETAILS_FIELDS',
  GEOFENCE_FILTER: 'GEOFENCE_FILTER',
  GRAZING_LIST: 'GRAZING_LIST',
  GROUPS_LIST: 'GROUPS_LIST',
  GROUP_DETAILS_FIELDS: 'GROUP_DETAILS_FIELDS',
  GROUP_FILTER: 'GROUP_FILTER',
  KRAAL_TAGS_LIST: 'KRAAL_TAGS_LIST',
  LAST_NOTIFICATIONS_WIDGET: 'LAST_NOTIFICATIONS_WIDGET',
  LIST_OF_NOTIFICATIONS: 'LIST_OF_NOTIFICATIONS',
  LIVESTOCK_ANALYSIS_WIDGET: 'LIVESTOCK_ANALYSIS_WIDGET',
  LIVESTOCK_COUNT_WIDGET: 'LIVESTOCK_COUNT_WIDGET',
  LIVESTOCK_DETAIL: 'LIVESTOCK_DETAIL',
  LIVESTOCK_ID_FILTER: 'LIVESTOCK_ID_FILTER',
  LIVESTOCK_LIST: 'LIVESTOCK_LIST',
  LIVESTOCK_PICTURE: 'LIVESTOCK_PICTURE',
  LIVESTOCK_WITH_NOTIFICATIONS_FITLER: 'LIVESTOCK_WITH_NOTIFICATIONS_FITLER',
  MAP_TRACKING: 'MAP_TRACKING',
  MAP_WIDGET: 'MAP_WIDGET',
  MEASURES_TAB: 'MEASURES_TAB',
  NOTIFICATION_DETAIL: 'NOTIFICATION_DETAIL',
  NOTIFICATION_ICON: 'NOTIFICATION_ICON',
  NOTIFICATION_LIST: 'NOTIFICATION_LIST',
  NOTIFICATION_TAB: 'NOTIFICATION_TAB',
  RULES_FILTER: 'RULES_FILTER',
  RULES_LIST: 'RULES_LIST',
  RULES_WIDGET: 'RULES_WIDGET',
  RULE_DETAILS_FIELDS: 'RULE_DETAILS_FIELDS',
  SITES_FILTER: 'SITES_FILTER',
  SITES_LIST: 'SITES_LIST',
  SITE_DETAILS_FIELDS: 'SITE_DETAILS_FIELDS',
  TAGS_FILTER: 'TAGS_FILTER',
  TASKS: 'TASKS',
  TASKS_WIDGET: 'TASKS_WIDGET',
  TRACK_ANIMAL: 'TRACK_ANIMAL',
  TREATMENT_TAB: 'TREATMENT_TAB',
  USER_ADDRESS_DETAILS: 'USER_ADDRESS_DETAILS',
  USER_NOTIFICATION_PREFERENCES: 'USER_NOTIFICATION_PREFERENCES',
  USER_PERSONAL_DETAILS: 'USER_PERSONAL_DETAILS',
  USER_PROFILE_PICTURE: 'USER_PROFILE_PICTURE',
  USER_SUMMARY_CARD: 'USER_SUMMARY_CARD',
  WEATHER_WIDGET: 'WEATHER_WIDGET'
};
